import type { Customer, ListStatuses, Workflow } from "~/types/api";
import type { ListDTO } from "../list.types";

export const transformListData = (
  list: {
    id: number;
    workflowId: number;
    name: string;
    statuses?: ListStatuses[];
  },
  allWorkflows?: Workflow[],
  allCustomers?: Customer[]
): ListDTO => {
  const listWorkflow = allWorkflows?.find((w) => w.id === list.workflowId);
  const listCustomer = allCustomers?.find((c) => c.id === listWorkflow?.customerId);

  return {
    id: list.id,
    name: list.name,
    workflow: {
      id: listWorkflow?.id ?? list.workflowId,
      name: listWorkflow?.name ?? "Loading...",
      version: listWorkflow?.version ?? NaN,
      state: listWorkflow?.state ?? "Unknown",
    },
    customer: {
      id: listCustomer?.id ?? 0,
      name: listCustomer?.name ?? "Loading...",
    },
    statuses: list.statuses || [],
  };
};
